module.exports = __webpack_public_path__ + "img/label2.c02e96d6.png";